<template>
  <base-card :projectID="projectID" :categoryID="categoryID" :storyType="storyType" :isMarginless="isMarginless" :isRowLoading="isRowLoading" :isPinnableRow="isPinnableRow" :pinnedProjects="pinnedProjects" :disableLink="disableLink" >
    <information :isRowLoading="isRowLoading" :isBlank="isBlank">
      <div class="top-line">
        <span class="category">
          {{ categoryName }}
        </span>
        <span class="author author-ajas " :class="{ 'is-hidden-touch': $isAjas,}">
          {{ajasAuthors}}
        </span>
      </div>
    </information>
    <project-title :isRowLoading="isRowLoading" :isBlank="isBlank" :title="title" :elementID="elementID" :customLineClamp="3" />
    <visibility-flags :project="project"></visibility-flags>
    <project-image :image="image" :isRowLoading="isRowLoading" :imageBackground="imageBackground" :isBlank="isBlank" :isVisible="isVisible" :projectAwards="project.awards" :imageOverlay="imageOverlay"/>
  </base-card>
</template>

<script>
import BaseCard from './BaseCard'
import base from '../mixins/base'
import visibility from '@/mixins/visibility'
import ProjectTitle from '../UI/Title'
import Information from '../UI/Information'
import CategoryCircles from '../UI/Category.vue'
import ProjectImage from '../UI/ProjectImage'
import User from '../UI/User'
import VisibilityFlags from '@/components/Cards/ProjectCards/UI/visibilityFlags'
export default {
  name: 'Ajas',
  components: {
    BaseCard,
    ProjectTitle,
    Information,
    ProjectImage,
    User,
    CategoryCircles,
    VisibilityFlags
  },
  data: function () {
    return {
      ajasAuthors: ''
    }
  },
  mounted: function () {
    this.filterAjasMembers()
  },
  props: ['projectID', 'categoryID', 'storyType', 'isMarginless', 'isRowLoading', 'isPinnableRow', 'pinnedProjects', 'disableLink'],
  mixins: [base, visibility],
  computed: {
    showCategories: function () {
      return !this.$isBroadcomMasters
    }
  },
  methods: {
    filterAjasMembers: function () {
      this.members = this.members.slice(0, 2)
      if (this.members?.length > 1) {
        let authors = ''
        this.members.forEach(function (user, index) {
          if (index === 0) {
            if (user.firstName && user.lastName) {
              authors = authors + user.firstName + ' ' + user.lastName[0].toUpperCase() + '.'
            } else {
              authors = authors + user.userName
            }
          } else {
            if (user.firstName && user.lastName) {
              authors = authors + ' & ' + user.firstName + ' ' + user.lastName[0].toUpperCase() + '.'
            } else {
              authors = authors + ' & ' + user.userName
            }
          }
        })
        this.ajasAuthors = authors
      } else {
        this.ajasAuthors = this.author
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  ::v-deep .story-card {
    border-radius: 0;
  }
  .top-line {
    height: 55px;
    display: flex;
    flex-direction: column;
    margin: 1rem 0 0 0.75rem;
    height: 2.1rem;
    overflow-wrap: break-word;
    white-space: nowrap;
    font-size: .75rem;
    overflow: hidden;
    width: 179px;
    text-overflow: ellipsis;
    letter-spacing: 0;
    .category {
      color: #00adee;
      font-weight: 500;
      margin-right: 0.25rem;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .author {
    color: #aaa;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: capitalize;
    }
  }
</style>
